import React, { useEffect, useRef, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'

export default function AnimacionScroll() {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  // Animación con entrada y salida
  const estilos = useSpring({
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0px)' : 'translateY(40px)',
    config: { tension: 120, friction: 25 }
  })

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Si el elemento entra en pantalla → aparece
        if (entry.isIntersecting) {
          setVisible(true)
        } else {
          // Si sale de pantalla → desaparece
          setVisible(false)
        }
      },
      { threshold: 0.5 } // Se activa cuando el 50% del elemento es visible
    )

    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

 return (
  <div style={{ textAlign: 'left', marginTop: '0px' }}>
    <animated.h2 ref={ref} style={estilos}>
      <span
        style={{
          leading: 'relaxed',
          fontSize: '18px',
          fontWeight: '400',
          color: '#94a3b8',
          fontFamily: "Space Grotesk, sans-serif"
        }}> Escaneos precisos con tecnologia de video 360° para capturar cada detalle estructural de tu propiedad con Matterport 3D.
          </span>
    </animated.h2>
  </div>
)}




